import PropTypes from 'prop-types';
// material
import Typography from '@mui/material/Typography';

ItemVoucherStatus.propTypes = {
  item: PropTypes.object
};

export default function ItemVoucherStatus({ item }) {
  if (item.ticket.isValid === false) {
    return <Typography color="error">Voucher not applicable</Typography>;
  }

  return <></>;
}
